import React, { useState, useContext } from 'react';
import { LanguageContext } from '../../App';
import { PlusIcon, UserPlusIcon, BellIcon, MessageSquareIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { staggerContainer, listItem, buttonHover, buttonTap } from '../../utils/animations';
import { AddOrderModal } from './modals/AddOrderModal';
import { AssignDriverModal } from './modals/AssignDriverModal';
import { BroadcastModal } from './modals/BroadcastModal';
import { MessageAllModal } from './modals/MessageAllModal';
import { useNotification } from '../../hooks/useNotification';
export const QuickActions: React.FC = () => {
  const {
    language
  } = useContext(LanguageContext);
  const {
    toast,
    notify,
    alert
  } = useNotification();
  const [isAddOrderModalOpen, setIsAddOrderModalOpen] = useState(false);
  const [isAssignDriverModalOpen, setIsAssignDriverModalOpen] = useState(false);
  const [isBroadcastModalOpen, setIsBroadcastModalOpen] = useState(false);
  const [isMessageAllModalOpen, setIsMessageAllModalOpen] = useState(false);
  const actions = [{
    id: 'add-order',
    icon: <PlusIcon size={20} data-id="element-554" />,
    label: language === 'en' ? 'Add Order' : 'إضافة طلب',
    color: 'bg-congress-blue-600 hover:bg-congress-blue-700',
    onClick: () => {
      console.log('Opening Add Order Modal');
      setIsAddOrderModalOpen(true);
    }
  }, {
    id: 'assign-driver',
    icon: <UserPlusIcon size={20} data-id="element-555" />,
    label: language === 'en' ? 'Assign Driver' : 'تعيين سائق',
    color: 'bg-regent-st-blue-600 hover:bg-regent-st-blue-700',
    onClick: () => {
      console.log('Opening Assign Driver Modal');
      setIsAssignDriverModalOpen(true);
    }
  }, {
    id: 'broadcast',
    icon: <BellIcon size={20} data-id="element-556" />,
    label: language === 'en' ? 'Broadcast' : 'إرسال تعميم',
    color: 'bg-green-600 hover:bg-green-700',
    onClick: () => {
      console.log('Opening Broadcast Modal');
      setIsBroadcastModalOpen(true);
    }
  }, {
    id: 'message-all',
    icon: <MessageSquareIcon size={20} data-id="element-557" />,
    label: language === 'en' ? 'Message All' : 'رسالة للجميع',
    color: 'bg-yellow-600 hover:bg-yellow-700',
    onClick: () => {
      console.log('Opening Message All Modal');
      setIsMessageAllModalOpen(true);
    }
  }];
  const closeAddOrderModal = () => {
    console.log('Closing Add Order Modal');
    setIsAddOrderModalOpen(false);
    // Show success toast
    toast({
      title: language === 'en' ? 'Order Added Successfully' : 'تمت إضافة الطلب بنجاح',
      type: 'success',
      message: language === 'en' ? 'The order has been added to the system.' : 'تمت إضافة الطلب إلى النظام.'
    });
  };
  const closeAssignDriverModal = () => {
    console.log('Closing Assign Driver Modal');
    setIsAssignDriverModalOpen(false);
    // Show success notification
    notify({
      title: language === 'en' ? 'Driver Assigned' : 'تم تعيين السائق',
      type: 'success',
      message: language === 'en' ? 'The driver has been assigned to the order and notified.' : 'تم تعيين السائق للطلب وإشعاره.',
      actionText: language === 'en' ? 'View Order' : 'عرض الطلب',
      onAction: () => console.log('View order clicked')
    });
  };
  const closeBroadcastModal = () => {
    console.log('Closing Broadcast Modal');
    setIsBroadcastModalOpen(false);
    // Show info notification
    notify({
      title: language === 'en' ? 'Broadcast Sent' : 'تم إرسال التعميم',
      type: 'info',
      message: language === 'en' ? 'Your broadcast message has been sent to all drivers.' : 'تم إرسال رسالة التعميم إلى جميع السائقين.'
    });
  };
  const closeMessageAllModal = () => {
    console.log('Closing Message All Modal');
    setIsMessageAllModalOpen(false);
    // Show alert
    alert({
      title: language === 'en' ? 'Messages Sent' : 'تم إرسال الرسائل',
      type: 'warning',
      message: language === 'en' ? 'Your message has been sent to the selected drivers. Please note that they may be busy driving.' : 'تم إرسال رسالتك إلى السائقين المحددين. يرجى ملاحظة أنهم قد يكونون مشغولين بالقيادة.',
      actionText: language === 'en' ? 'Track Responses' : 'تتبع الردود',
      onAction: () => console.log('Track responses clicked')
    });
  };
  return <>
      <motion.div className="grid grid-cols-2 gap-3" variants={staggerContainer} initial="hidden" animate="visible" data-id="element-558">
        {actions.map(action => <motion.button key={action.id} onClick={action.onClick} className={`flex items-center justify-center px-4 py-2 rounded-md text-white text-sm font-medium ${action.color} transition-colors duration-200`} variants={listItem} whileHover={buttonHover} whileTap={buttonTap} data-id="element-559">
            {action.icon}
            <span className="ml-2" data-id="element-560">{action.label}</span>
          </motion.button>)}
      </motion.div>
      {/* Modals */}
      <AddOrderModal isOpen={isAddOrderModalOpen} onClose={closeAddOrderModal} data-id="element-561" />
      <AssignDriverModal isOpen={isAssignDriverModalOpen} onClose={closeAssignDriverModal} data-id="element-562" />
      <BroadcastModal isOpen={isBroadcastModalOpen} onClose={closeBroadcastModal} data-id="element-563" />
      <MessageAllModal isOpen={isMessageAllModalOpen} onClose={closeMessageAllModal} data-id="element-564" />
    </>;
};